import React, { useState } from "react";
import SEO from "../components/SEO";
import { MaskLineScroll } from "../components/Reveal";
import { BRAND } from "../lib/brand";
import { sendContact } from "../lib/api";

export default function Careers() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "", honeypot: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await sendContact({
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: `[Careers] ${form.message}`,
        honeypot: form.honeypot,
      });
      setSent(true);
    } catch { /* ignore */ }
    finally { setBusy(false); }
  };

  return (
    <>
      <SEO
        title="Careers — Work with ProForm Paint & Body"
        description="ProForm is always interested in hearing from skilled paint techs, body techs, prep specialists, and detailers who take craft seriously."
        canonical={`https://${BRAND.domain}/careers`}
      />
      <section className="pt-32 md:pt-40 pb-16 border-b border-ink-700">
        <div className="wrap">
          <div className="label mb-3">— Careers · 001</div>
          <h1 className="font-display uppercase text-5xl md:text-8xl leading-[0.88] tracking-tight max-w-4xl">
            <MaskLineScroll>Craft over</MaskLineScroll>
            <MaskLineScroll delay={0.08}>volume. <span className="text-proform-red">Always</span>.</MaskLineScroll>
          </h1>
          <p className="mt-8 text-chrome-300 max-w-2xl text-lg leading-relaxed">
            No open listings today. If you&apos;re a body tech, paint tech, prep specialist, detailer, or estimator with a serious portfolio, get in touch — we keep a running file.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="wrap max-w-2xl">
          {sent ? (
            <div className="card p-8 text-center">
              <div className="label mb-2">— Received</div>
              <div className="font-display text-3xl">Thanks — we&apos;ll be in touch.</div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="field-label" htmlFor="cn">Name</label>
                <input id="cn" required className="field" value={form.name} onChange={set("name")} />
              </div>
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="field-label" htmlFor="ce">Email</label>
                  <input id="ce" required type="email" className="field" value={form.email} onChange={set("email")} />
                </div>
                <div>
                  <label className="field-label" htmlFor="cp">Phone</label>
                  <input id="cp" type="tel" className="field" value={form.phone} onChange={set("phone")} />
                </div>
              </div>
              <div>
                <label className="field-label" htmlFor="cm">Experience &amp; specialty</label>
                <textarea id="cm" rows={5} className="field" value={form.message} onChange={set("message")} />
              </div>
              <input tabIndex={-1} autoComplete="off" value={form.honeypot} onChange={set("honeypot")}
                     className="absolute -left-[9999px]" aria-hidden />
              <button className="btn btn-primary" disabled={busy}>{busy ? "Sending…" : "Send →"}</button>
              <p className="label">Or email <a href={`mailto:${BRAND.email}`} className="underline">{BRAND.email}</a></p>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
